// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmFooter = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setFooterSpacing = function($context) {
			var footer_height = $context.height();

			$('main').not('[class^="Main-"]').css({
				paddingBottom: footer_height+'px',
				marginBottom: '-'+footer_height+'px'
			});
		}

		// On load function
		methods.events = function($context) {
			var resizeTimer = null;

			$(window).resize(function(){
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function(){
					methods.setFooterSpacing($context);
				}, 250);
			});

			methods.setFooterSpacing($context);
		}

		methods.events(this);

		return this;
	};
}(jQuery));